import type { ProjectId } from "features/shared/model/types";
import type { QueryKey } from "react-query";

export type ConfigTabCacheKeys = {
  detail: (projectId: ProjectId, recordId?: string, scenario?: string) => QueryKey;
  groups: (projectId: ProjectId, scenario?: string) => QueryKey;
};

export const createConfigTabCacheKeys = (root: string): ConfigTabCacheKeys => ({
  detail: (projectId, recordId, scenario) =>
    scenario
      ? ([root, "detail", projectId, recordId, scenario] as const)
      : ([root, "detail", projectId, recordId] as const),
  groups: (projectId, scenario) =>
    scenario ? ([root, "groups", projectId, scenario] as const) : ([root, "groups", projectId] as const),
});

export type AllCacheKeys = ConfigTabCacheKeys & {
  catalog: QueryKey;
};
